<template lang="pug">
    v-layout
        v-content
            v-container(text-lg-right='', fill-height='')
                v-layout(row='', wrap='', align-top='')
                    v-flex.text-xs-center
                        .rtl
                            router-link.router-link(v-if="s.show_in_home_page" v-for="s in screans" target="_blank" tag='a', :to="'/screen/' + s.id")
                                v-tooltip(top)
                                    v-btn.white--text(slot='activator', :loading='loading3', :disabled='loading3', color='blue-grey', @click.native="loader = 'loading3'")
                                        |  {{s.name}}
                                        v-icon(left='', dark='') view_headline
                                    span  {{s.name}} לחץ לפתיחת מסך

</template>

<script>
    export default {
        // name : 'home',
        data: () => ({
            loader: null,

            screans: [],
            loading3: false,

        }),
        props: ['loading'],

        created() {

            this.$socket.on('*', (packet) => {
                let channel = packet.data[0];
                let data = packet.data[1];
                let $uniqid = data.$uniqid;
                if ($uniqid) {
                    return this.$socket.res(data);
                }
                this.sockets(channel, data);
            });

            this.$emit('update:loading', false);

            this.$socket.req('sendi.screen.all', {user: this.$user}).then(data => {
                this.screans = data.entities;
            });
        },
        beforeRouteLeave(to, from, next) {
            this.$socket.off('*');
            this.$emit('update:loading', true);
            next();
        },
        methods: {
            sockets: function (channel, data) {
                let channels = {
                    'sum.channel': (data) => {
                        console.log('sum.channel')
                    }
                };
                if (!channels[channel]) {
                    return console.log('Socket channel not found:', channel);
                }

                return channels[channel](data);
            }
        },

        watch: {
            loader() {
                const l = this.loader
                this[l] = !this[l]
                setTimeout(() => (this[l] = false), 3000)
                this.loader = null
            }
        }
    }
</script>

<style>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }

    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>